<template>
    <div v-if="isCurrentStep">
        <NextStep title="Maximize Your Job Offer">
            <p>Receiving an offer is a significant achievement, but your work isn't finished.</p>
            <br />
            <p>How you handle this stage can substantially impact your compensation and career trajectory.</p>
            <br />
            <p>Don't make hasty decisions.</p>
            <p>Take time to:</p>
            <ul class="list-disc ml-4">
                <li>Research comparable salaries for your position and location</li>
                <li>Document your specific achievements and value</li>
                <li>Identify your non-negotiable requirements</li>
            </ul>
            <br />
            <p>Remember that benefits often account for 30%+ of your total compensation.</p>
            <br />
            <p>Consider the complete package, not just the base salary.</p>
        </NextStep>
    </div>
    <div v-else-if="isStepPassed">
        <NextStep title="Review">
            <p>Congratulations, you’re offer stage is complete!</p>
        </NextStep>
    </div>
    <div v-else>
        <NextStep title="Preview">
            <p>
                Negotiate effectively by researching comparable salaries, documenting your achievements, and considering
                the full package (benefits can add 30%+ to base pay).
            </p>
            <br />
            <p>Don't rush this critical final stage!</p>
        </NextStep>
    </div>

    <button
        class="bg-won-green w-full text-white py-1.5 px-3 rounded text-sm"
        type="button"
        @click="() => emit('open-feature')"
    >
        Master Salary Negotiation →
    </button>

    <SidebarCard space-y="space-y-0">
        <span class="text-won-blue-light text-4xl font-semibold text-center">{{ offersCount }}</span>
        <span class="text-won-blue text-sm font-semibold text-center">Offers</span>
    </SidebarCard>

    <PlanTabGroup :tabs="tabs" />
</template>

<script setup>
import { storeToRefs } from "pinia";

import { useJobSearchPlanStore } from "../../../store/job-search-plan.store";

import NextStep from "../next-step.vue";
import SidebarCard from "../sidebar-card.vue";
import PlanTabGroup from "../plan-tab-group.vue";

import { UserGroupIcon, UserIcon } from "@heroicons/vue/20/solid";

const emit = defineEmits(["open-feature"]);
const props = defineProps({
    isStepPassed: {
        type: Boolean,
        default: false,
        required: true,
    },
    isCurrentStep: {
        type: Boolean,
        default: false,
        required: true,
    },
});

const jobSearchPlanStore = useJobSearchPlanStore();
const { offerRate, timeToOffer, offersCount } = storeToRefs(jobSearchPlanStore);

const tabs = [
    {
        title: "your average",
        icon: UserIcon,
        values: [
            { type: "percents", value: offerRate.value, label: "Offer Rate" },
            {
                type: "days",
                value: timeToOffer.value,
                label: "Time to Offer",
            },
        ],
        isComingSoon: false,
    },
    {
        title: "other users",
        icon: UserGroupIcon,
        isComingSoon: true,
    },
];
</script>
